import {appHref} from '../../../helper/app-href';
import {EvDateFns} from '../../components/ev-date-fns';
import {EvStatusLabel} from '../../components/labels/ev-status-label';
import {CustomerComment} from './customer-comment.models';

interface Props {
  comment: CustomerComment;
}

export function CustomerCommentBox({comment}: Props) {
  return <div className="whitebox mb-4!">
    <div className="grid grid-cols-2">
      <div>
        <h5>
          <i className="fa fa-user"/> Benutzer: {comment.username} -&nbsp;
          <a href={appHref(`/workflow/${comment.workflowId}`)} target="_blank">
            Vorgang: {comment.workflowId}
          </a>
          &nbsp;&nbsp;
          <EvStatusLabel type="workflow_status"
                         state={comment.workflowStatus}
                         className="px-3! py-2.5!"/>
        </h5>
      </div>
      <div className="text-right">
        Datum: <EvDateFns date={comment.date} formatIn="iso" formatOut="dd.MM.yyyy HH:mm"/>
      </div>
    </div>
    <div className="mb-2.5">
      <pre>{comment.text}</pre>
    </div>
  </div>;
}
